require('./core');

require('./builders/account_builder');
require('./builders/login_attempt_builder');
require('./builders/student_type_builder');
require('./builders/student_term_builder');

require('./commands/confirm_account_command');
require('./commands/create_account_command');
require('./commands/initialize_anonymous_user_activity_command');
require('./commands/initialize_google_tag_manager_command');
require('./commands/load_student_types_command');
require('./commands/load_student_terms_command');
require('./commands/login_command');
require('./commands/logout_anonymous_command');
require('./commands/logout_command');
require('./commands/logout_notification_command');
require('./commands/request_anonymous_account_command');
require('./commands/resend_confirm_account_command');
require('./commands/resend_reset_password_command');
require('./commands/reset_local_account_command');
require('./commands/reset_password_command');
require('./commands/reset_password_email_command');
require('./commands/restore_local_account_command');
require('./commands/save_additional_information_command');
require('./commands/set_info_user_tracking_command');
require('./commands/update_expire_time_command');
require('./commands/update_profile_command');
require('./commands/validate_password_command');
require('./commands/validate_reset_password_key');
require('./commands/validate_token_command');

require('./components/captcha_widget/captcha_widget');
require('./components/password_validation_popover/password_validation_popover');
require('./components/revealable_password/revealable_password');

require('./configuration/include_authentication_header_interceptor');
require('./configuration/session_expire_update_interceptor');
require('./configuration/route_configuration');

require('./datasources/account_datasource');
require('./datasources/login_attempts_datasource');
require('./datasources/student_types_datasource');
require('./datasources/student_terms_datasource');

require('./queries/student_types_query');
require('./queries/student_terms_query');

require('./servants/account_servant');
require('./servants/profile_servant');

require('./views/additional_information/additional_information');
require('./views/confirm_account/confirm_account');
require('./views/create_profile/create_profile');
require('./views/email_sent/email_sent');
require('./views/enter_email/enter_email');
require('./views/login/login');
require('./views/my/my');
require('./views/profile_menu/profile_menu');
require('./views/reset_password/reset_password');
require('./views/update_profile/update_profile');



// WEBPACK FOOTER //
// ./app/lib/user_app/main.ts